import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io"
import styled from "styled-components"
import textBoldMaker from "../../../helper/textBoldMaker"

const Container = styled.div`
    width: 80%; 
    display: flex;
    flex-direction: column;
    height: auto;
    border-top: ${({isActive}) => isActive ? "3px solid var(--color-main)": "3px solid transparent"};
    color: ${({theme}) => theme.mainTextColor};

    .question{
        width: 100%;
        padding: 15px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: ${({ theme }) => theme.accTopColor};
        cursor: pointer;

        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-xl);
        }


        .icon{
            transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
            fill: ${({theme, isActive}) => isActive ? "var(--color-main)": theme.mainTextColor};
            transition: .5s;
            font-size: 1.4rem;
        }
    }

    .answer{
        max-height: 0;
        overflow: hidden;
        background-color: ${({theme}) => theme.accBottomColor};
    }

    .answer-active{
        height: auto;
        /* max-height: ${({isActive}) => isActive ? "500px": 0}; */
        max-height: 500px;
        overflow: hidden;
        /* transition: all 5s; */
        transition: max-height 2s;
        background-color: ${({theme}) => theme.accBottomColor};
        font-weight: var(--font-weight-md);
        font-size: var(--font-size-md);

        p{
            padding: 20px;
        }
        ul{
            padding: 0px 20px 20px 40px;
            display: flex;
            flex-direction: column;
            gap: 10px;
            li{
                list-style-type: initial !important;
            }
        }
        .bold{
            font-weight: var(--font-weight-xl);
        }
}

@media (max-width: 850px){
  width: 100% !important;
  
}

`


const SssAccordionItem = ({item, handleClick}) => {
  return (
    <Container isActive={item.isOpened}>
            <div className="question" onClick={() => handleClick(item)}>
                <p>{item.question}</p>
                <IoIosArrowForward className={"icon"}/>
            </div>
            <div className={item.isOpened ? "answer-active": "answer"}>
                <p dangerouslySetInnerHTML={{ __html: textBoldMaker(item.answer) }}/>
                {
                    item?.list &&
                    <ul>
                        {
                            item?.list?.map((item) => (
                                <li>{item?.text}</li>
                            ))
                        }
                    </ul>
                }
                
            </div>
        </Container>
  )
}

export default SssAccordionItem